import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export interface ModalProps {
  children?: React.ReactNode;
  className?: string;
  bgClassName?: string;
  open: boolean;
  footer?: React.ReactNode;
  onClose?: () => void;
  render?: (data: any) => any;
}

const Modal: React.FC<ModalProps> = ({
  children,
  className = '',
  bgClassName = 'shadow-lg bg-primary text-white border-primary',
  onClose,
  footer,
  open,
}) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="pt-4 px-4 pb-20 text-center sm:block sm:p-0" onClose={onClose ? onClose : () => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity z-20" />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Dialog.Description as="div" data-cy="modal" className={`absolute flex flex-col inset-0 items-center justify-center z-30 `}>
            <div className={`flex flex-col border mx-2 sm:mx-0 rounded-xl p-8 gap-8 sm:p-12 sm:gap-12 max-w-xl ${bgClassName} ${className}`}>
              <div className="flex-1 text-left">{children}</div>
              {footer && <footer className="flex flex-wrap items-center justify-between">{footer}</footer>}
            </div>
          </Dialog.Description>
          {/* <Dialog.Description
            as="div"
            data-cy="modal"
            className={`absolute text-left flex flex-col inset-x-5 inset-y-1/3 sm:inset-x-1/4 sm:inset-y-1/3 mx-auto border rounded-xl z-30 p-5 sm:p-16 ${bgClassName} ${className}`}
          >
            <div className="">

            <div className="flex-1 text-lg font-bold">{children}</div>
            {footer && <footer className="flex items-center justify-between">{footer}</footer>}
            </div>
          </Dialog.Description> */}
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default Modal;
